

module.exports = __webpack_require__.stylable.create(
    "WeeklyCalendar2022076764",
    {"classes":{"root":"WeeklyCalendar2022076764__root","CalendarExt":"WeeklyCalendar2022076764__CalendarExt","WeeklyWithWrapper":"WeeklyCalendar2022076764__WeeklyWithWrapper","timeToDisplay":"WeeklyCalendar2022076764__timeToDisplay","PrefixedBottom":"WeeklyCalendar2022076764__PrefixedBottom"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size:'16px', lineHeight: '1.4em'}\"","PickerFont":"\"fallback(font(--weekFont), font({theme: 'Body-M', size:'16px', lineHeight: '1.4em'}))\"","PickeColor":"\"fallback(color(--weekFontColor), color(color-5))\"","BackgroundColor":"\"fallback(color(--calendarBackgroundColorWithoutOpacity), color(color-1))\""},"keyframes":{}},
    "",
    20,
    "WeeklyCalendar2022076764",
    null
);
